<!-- <div *ngIf="otherDevice">
<router-outlet></router-outlet>
</div>
<div *ngIf="!otherDevice">
    <h5 class="text-center pt-40 fs-16">Please use Arevea TV Mobile apps</h5>
</div> -->
<ng-container *ngIf="(deviceInfo == 'android' ) && deviceType == 'browser' && hideContent">
    <h5 class="text-center pt-40 fs-16 plr-10">
        Please download {{clientDetails.name}}'s app from Play Store to watch the {{content}} stream on mobile.</h5>
    <div class="text-center mt-20">
        <a href="https://play.google.com/store/apps/details?id=com.arevea.tv"><img
                [src]="assets_url+'website/homepage/googleplay.png'" class="store-img"></a>
    </div>
</ng-container>
<ng-container *ngIf="(deviceInfo == 'ios' ) && deviceType == 'browser' && hideContent">
    <h5 class="text-center pt-40 fs-16 plr-10">Please download {{clientDetails.slug}}'s app from App Store to watch the
        {{content}}
        stream on mobile.</h5>
    <div class="text-center mt-20">
        <a href="https://apps.apple.com/in/app/arevea/id1535047464"><img
                [src]="assets_url+'website/homepage/appstore.png'" class="store-img"></a>
    </div>
</ng-container>
<!-- <div *ngIf="!otherDevice" fxLayout="row">
    <span><i class="fa fa-close f-r fs-22" (click)="closePopup()"></i></span>
    <img src="assets/mobile-logo.png" height="40">
    <h6>hkjhhkhkj</h6>
    <button
                            mat-flat-button class="flat-primary-button" (click)="getTickets()">Get Tickets</button>
</div> -->
<ng-container *ngIf="(!hideContent || deviceInfo == 'web') && enable_aichatbot">
    <router-outlet></router-outlet>
    <div *ngIf="!hideAIChatbot">
        <!-- <app-ai-assistant></app-ai-assistant> -->
        <!-- environment.enableNewAgentHome: redesigned agent (v2); false restores the previous design. -->
        <app-ai-agent-v2 *ngIf="newAgentHome"></app-ai-agent-v2>
        <app-ai-agent *ngIf="!newAgentHome"></app-ai-agent>
    </div>
    <ngx-ui-loader [textColor]="loaderTextColor" [overlayColor]="loaderOverlayColor"></ngx-ui-loader>
</ng-container>
<ng-container class="private-chat"
    *ngIf="!hidePrivateChat && (userInfo?.signedIn || router.url.includes('/stream/') || router.url.includes('/event/schedule/')) && (!router.url.includes('/payment/') && !router.url.includes('/private-chat/') && !router.url.includes('/contacts/')) && !router.url.includes('/preview') && !router.url.includes('/place-order') && deviceType == 'browser' && deviceInfo == 'web'">
    <app-private-chat></app-private-chat>
</ng-container>